import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { apiError, TOKEN_KEY, TENANT_KEY } from "../api";
import { useAuth } from "../AuthContext";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

const black = "#111111";

export default function Activate() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");
  const done = useRef(false);

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); setMessage("Link de activare invalid"); return; }
    if (done.current) return;
    done.current = true;
    (async () => {
      try {
        const { data } = await api.post("/auth/activate", { token });
        localStorage.setItem(TOKEN_KEY, data.access_token);
        if (data.tenant_id) localStorage.setItem(TENANT_KEY, data.tenant_id);
        setState("ok");
        if (refresh) await refresh();
        setTimeout(() => { window.location.href = "/site"; }, 1200);
      } catch (err) {
        setState("error");
        setMessage(apiError(err, "Activare esuata"));
      }
    })();
  }, [params, nav, refresh]);

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ backgroundColor: "#ffffff", color: black, fontFamily: "Arial, sans-serif", fontSize: "12px" }}
    >
      <div className="w-full max-w-md text-center" data-testid="activate-page">
        {state === "loading" && (
          <>
            <Loader2 className="w-10 h-10 animate-spin mx-auto mb-6" style={{ color: black }} />
            <h2 style={{ fontSize: "20px" }} className="font-bold">Activam contul...</h2>
          </>
        )}
        {state === "ok" && (
          <>
            <div className="w-14 h-14 rounded-md border border-gray-300 flex items-center justify-center mx-auto mb-6">
              <CheckCircle2 className="w-7 h-7" style={{ color: black }} />
            </div>
            <h2 style={{ fontSize: "20px" }} className="font-bold" data-testid="activate-success">Cont activat</h2>
            <p className="mt-2" style={{ fontSize: "13px" }}>Te ducem in aplicatie...</p>
          </>
        )}
        {state === "error" && (
          <>
            <div className="w-14 h-14 rounded-md border border-gray-300 flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-7 h-7" style={{ color: black }} />
            </div>
            <h2 style={{ fontSize: "20px" }} className="font-bold" data-testid="activate-error">Activare esuata</h2>
            <p className="mt-2" style={{ fontSize: "13px" }}>{message}</p>
            <Link to="/login" className="mt-6 inline-block underline">Mergi la autentificare</Link>
          </>
        )}
      </div>
    </div>
  );
}
